import { Link, useLocation } from "react-router-dom";
import { useAuth } from "../lib/auth";

/**
 * Two marks on one row: the lockup, and the feed.
 *
 * The layout still borrows the watched storefront's wide three-up header, but
 * there is no storefront link here — the landing page already is the full view,
 * so a second way to reach it would be a nav item that goes nowhere new.
 */
export default function Header() {
  const { pathname } = useLocation();
  const { isAdmin } = useAuth();

  const watchActive = pathname.startsWith("/feed");
  const homeActive = pathname === "/" || pathname.startsWith("/p/");

  return (
    <header className="ap-header ap-header--duo">
      <Link
        to="/"
        className="ap-brand"
        aria-label="Anti Watcher — home"
        aria-current={homeActive ? "page" : undefined}
      >
        <span className="ap-brand__mark" aria-hidden="true">
          Anti
        </span>
        <span className="ap-brand__mark" aria-hidden="true">
          Watcher
        </span>
      </Link>

      {/* The feed is operator-only, so a visitor is not shown a door they
          cannot open. */}
      {isAdmin && (
        <Link
          to="/feed"
          className={`ap-header__link${watchActive ? " is-active" : ""}`}
          aria-current={watchActive ? "page" : undefined}
        >
          Watch
        </Link>
      )}

    </header>
  );
}
